import Vue from "vue";

export const downloads = {
  namespaced: true,
  state: {
    files: [],
    isOpenDialogExport: false,
    isOpenDialogMessage: false,
    file: {}
  },
  getters: {
    files: state => state.files,
    isOpenDialogExport: state => state.isOpenDialogExport,
    isOpenDialogMessage: state => state.isOpenDialogMessage
  },
  actions: {
    async getFiles({ commit }) {
      try {
        const { data } = await this.$axios.get(`/admin/files`);
        commit("setFiles", data);
      } catch (error) {
        Vue.noty.error(this.i18n.tc("downloads.messages.error_get_files"));
      }
    },
    async getFile({ commit }, payload) {
      try {
        const { file_id, orgId } = payload;

        const { data } = await this.$axios.get(`/o/${orgId}/files/${file_id}`, {
          responseType: "blob"
        });

        commit("setFile", data);
      } catch (error) {
        Vue.noty.error(this.i18n.tc("downloads.messages.error_download"));
      }
    },
    async exportData({ commit, rootState }, payload) {
      /* const { id: orgId } = rootState.auth.user.organization */
      try {
        const { success } = (
          await this.$axios.post(`/admin/exports/drb`, payload)
        ).data;
        return { success };
      } catch (error) {
        Vue.noty.error(this.i18n.tc("downloads.messages.error_create"));
        return { success: false };
      }
    },
    async exportDataLead({ commit }, payload) {
      try {
        const { success } = (
          await this.$axios.post(`/admin/exports/leads`, payload)
        ).data;
        return { success };
      } catch (error) {
        if (error.response.data.message === "not_found") {
          Vue.noty.error(
            this.i18n.tc("general.not_found", null, { name: "Lead" })
          );
        } else {
          Vue.noty.error(this.i18n.tc("downloads.messages.error_create"));
        }
        return { success: false };
      }
    }
  },
  mutations: {
    setFiles(vuexStore, payload) {
      vuexStore.files = payload;
    },
    toggleDialogExport(vuexStore, payload) {
      vuexStore.isOpenDialogExport = payload;
    },
    toggleDialogMessage(vuexStore, payload) {
      vuexStore.isOpenDialogMessage = payload;
    },
    setFile(vuexStore, payload) {
      vuexStore.file = payload;
    }
  }
};
